<template>
  <div class="market-contract-horizontal-sushi-orders">
    <template v-if="hasOffers">
      <div class="market-contract-horizontal-sushi-orders__values">
        <span :class="buyValueClass" :data-tooltip="`Buy: ${buyQuantityFormatted}`">{{
          buyQuantityDisplay
        }}</span>
        <span class="market-contract-horizontal-sushi-orders__sep">/</span>
        <span :class="sellValueClass" :data-tooltip="`Sell: ${sellQuantityFormatted}`">{{
          sellQuantityDisplay
        }}</span>
      </div>
    </template>
    <span class="market-dash-symbol" v-else>-</span>
  </div>
</template>

<script src="./market-contract-horizontal-sushi-orders.js"></script>
<style src="./market-contract-horizontal-sushi-orders.scss" lang="scss"></style>
